import { createListReducer } from "./base-reducer";
import BankAccountActions from "../constants/actions";
import { LenderAccountRecord } from "./../records";

const listReducer = createListReducer(BankAccountActions.LENDER_ACCOUNTS.LIST, LenderAccountRecord);
const createUpdateReducer = createListReducer(BankAccountActions.LENDER_ACCOUNTS.ACCOUNT, LenderAccountRecord);

export default (state, action) => {
    return [
        listReducer,
        createUpdateReducer
    ].reduce((state, reducer) => reducer(state, action), state);
};